import { setCartItems, setIsCartUpdated } from "@/redux/slice/cart/slice";
import { CartItem } from "@/redux/slice/cart/types/CartItem";

export const replaceCartItems = (newCartItems: Array<CartItem>, dispatch: any) => {
  if (newCartItems) {
    const items = [...newCartItems];
    const freeProducts = items.filter((cartItem: CartItem) => cartItem.couponFree);
    const normalProducts = items.filter((cartItem: CartItem) => !cartItem.couponFree);
    dispatch(setCartItems(normalProducts.concat(freeProducts)));
    dispatch(setIsCartUpdated(true));
  }
};
